import CRUDService from 'src/services/crud-service';

export interface Country {
  name: string;
  code: string;
}

export default new CRUDService<Country>('/v1/countries');
